import React from 'react'

const TermPolicy = () => {
  return (
    <div>TermPolicy</div>
  )
}

export default TermPolicy;